module.exports = __webpack_public_path__ + "img/skilled.453dc85b.png";